import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';

// Pages
import Destiny2Lore from './pages/destinyLore';
import PortfolioPage from './pages/portfolio';
import StoreMap from './pages/store';
import Halo from './pages/halo';
import Home from './pages/home';

//Components
import Navbar from './components/navbar';
import MarathonWallpapers from './pages/marathon';


import DoomscrollMain from './pages/doomscroll/doomscroll-main';
import FullPostPage from './pages/doomscroll/pages/fullPost';


export default function App() {

  // useEffect(() => {
  //   console.log(window.location.pathname);
  // }, [window.location.pathname]);

  return (
    <Router>
      {!window.location.pathname.includes("doomscroll") && <Navbar />}
      {/* <ScrollToTop /> */}
      <div className={`${window.location.pathname.includes("doomscroll") ? "doomscroll" : "content"}`}>
        <Routes>
          <Route path='/' element = {<Home />} />
          <Route path='/portfolio' element = {<PortfolioPage />} />
          <Route path='/destiny-2' element = {<Destiny2Lore />} />
          <Route path='/marathon' element = {<MarathonWallpapers />} />
          <Route path='/halo-infinite' element = {<Halo />} />
          <Route path='/store' element = {<StoreMap />} />
          <Route path='/doomscroll' element = {<DoomscrollMain />} />
          <Route path="/doomscroll/post" element={<FullPostPage />} />
        </Routes>
      </div>
    </Router>
  );
}